<template>
  <tr :class="{'is-marked': marked}">
    <td>
      <a
        :href="physicalAssetTypeUrl"
      >{{name}}</a>
      <div v-if="description" class="note">{{description}}</div>
    </td>

    <td>
      <Details :details="details" />
    </td>

    <td class="table-row-actions">
      <RowAction
        :href="physicalAssetTypeUrl"
        action="read"
      />

      <RowAction
        v-if="policyUpdate"
        :href="physicalAssetTypeUrl + '/edit'"
        action="update"
      />

      <RowAction
        v-if="policyUpdate"
        :href="physicalAssetTypeUrl"
        action="delete"
      />
    </td>
  </tr>
</template>

<script>
import Row from "../shared/grid/row";
import RowAction from "../shared/grid/row_action";
import Details from "../shared/grid/details";

export default {
  extends: Row,

  components: {
    RowAction,
    Details
  },

  props: {
    id: String,
    name: String,
    description: String,
    details: String
  },

  computed: {
    physicalAssetTypeUrl: function () {
      return "/physical_asset_types/" + this.id;
    }
  }
}
</script>
